module.exports = __webpack_public_path__ + "static/media/Apple.91b0258c.svg";